import React from "react";
import "../styles/Hero.css";
import { 
  FaHtml5, FaCss3Alt, FaJs, FaReact, FaPython, FaDatabase 
} from "react-icons/fa";
import { SiMongodb, SiRedux, SiD3Dotjs } from "react-icons/si";

export default function Hero() {
  return (
    <section className="hero" id="hero">
      <div className="hero-content">
        <h1>Hi, I'm <span>Sai Bairavan</span></h1>
        <p>Full Stack Developer | Data Analyst</p>
        <a href="assets/resume.pdf" className="hero-btn">Download Resume</a>
      </div>

      {/* Floating icons */}
      <FaHtml5 className="float-icon" style={{top:"5%", left:"10%"}} />
      <FaCss3Alt className="float-icon" style={{top:"20%", right:"15%"}} />
      <FaJs className="float-icon" style={{top:"35%", left:"25%"}} />
      <FaReact className="float-icon" style={{bottom:"20%", right:"20%"}} />
      <FaPython className="float-icon" style={{bottom:"10%", left:"15%"}} />
      <FaDatabase className="float-icon" style={{top:"50%", right:"5%"}} />
      <SiMongodb className="float-icon" style={{bottom:"30%", left:"35%"}} />
      <SiRedux className="float-icon" style={{top:"60%", right:"25%"}} />
      <SiD3Dotjs className="float-icon" style={{bottom:"15%", right:"40%"}} />
    </section>
  );
}
